import {
	getWatchlist,
	saveWatchlistEntry,
	updateWatchlistEntry,
	deleteWatchlistEntry,
} from '@/services/community/wikigamer/games/price-watchlist'

export default {
	namespaced: true,
	state: {
		watchlist: {
			data: [],
			meta: {
				total: 0,
			},
		},
		watchlistStatus: 'init',
	},
	getters: {
		getWatchlist(state) {
			return state.watchlist
		},
		getWatchlistStatus(state) {
			return state.watchlistStatus
		},
	},
	mutations: {
		SET_WATCHLIST(state, value) {
			state.watchlist = value
		},
		SET_WATCHLIST_STATUS(state, value) {
			state.watchlistStatus = value
		},
	},
	actions: {
		async fetchWatchlist({ commit }, params) {
			commit('SET_WATCHLIST_STATUS', 'pending')
			try {
				const { data } = await getWatchlist(params)
				commit('SET_WATCHLIST', data)

				return data
			} finally {
				commit('SET_WATCHLIST_STATUS', 'init')
			}
		},
		async saveWatchlistEntry({ commit }, params) {
			commit('SET_WATCHLIST_STATUS', 'pending')
			try {
				const { data } = await saveWatchlistEntry(params)

				return data
			} finally {
				commit('SET_WATCHLIST_STATUS', 'init')
			}
		},
		async updateWatchlistEntry({ commit }, params) {
			commit('SET_WATCHLIST_STATUS', 'pending')
			try {
				const { data } = await updateWatchlistEntry(params)

				return data
			} finally {
				commit('SET_WATCHLIST_STATUS', 'init')
			}
		},
		async deleteWatchlistEntry({ commit }, params) {
			commit('SET_WATCHLIST_STATUS', 'pending')
			try {
				const { data } = await deleteWatchlistEntry(params)

				return data
			} finally {
				commit('SET_WATCHLIST_STATUS', 'init')
			}
		},
	},
}
